import { styled } from "styled-components";

export const CategoryName = styled.div`
  width: 100%;
  font-size: 18px;
  text-align: center;
`;
